import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { CONTENT } from "../data/siteConfig";

const LanguageContext = createContext(null);

const TITLES = {
  en: "Haya Beauty Care | Patient Coordination for Dental & Aesthetic Treatments in Istanbul",
  ar: "هيا بيوتي كير | تنسيق رحلات علاج الأسنان والتجميل في إسطنبول",
};

const detect = () => {
  try {
    const saved = localStorage.getItem("hbc-lang");
    if (saved === "ar" || saved === "en") return saved;
  } catch (e) {
    /* storage unavailable */
  }
  return (navigator.language || "en").toLowerCase().startsWith("ar") ? "ar" : "en";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(detect);

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    document.title = TITLES[lang];
    try {
      localStorage.setItem("hbc-lang", lang);
    } catch (e) {
      /* storage unavailable */
    }
  }, [lang]);

  const value = useMemo(
    () => ({
      lang,
      setLang,
      isRtl: lang === "ar",
      t: CONTENT[lang],
      toggle: () => setLang((l) => (l === "ar" ? "en" : "ar")),
    }),
    [lang],
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);
